import React from 'react';

import { type TImageBlock } from '@wp-block-builder/blocks/Image';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): TImageBlock => ({
  id: generateRandomBlockId(),
  type: 'Image',
  style: {
    textAlign: 'left',
    ...style,
  },
  props: {
    imageType: 'UPLOAD',
    url: null,
    urlTemplate: null,
    uploadId: null,
    alt: '',
    contentAlignment: 'middle',
    linkHref: null,
    height: null,
    width: null,
  },
  sectionProps: {},
});

export default defineBlockButton<TImageBlock>({
  label: 'Image',
  icon: <BlockTypeIcon type="Image" />,
  defaultBlock: () => getDefaultProps({ padding: '24px 24px 24px 24px' }),
  defaultContainerBlock: () => getDefaultProps({ padding: '24px 0px 24px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
